import { TIER_DISPLAY_NAMES } from '@/atoms/subscription.atom';
import { useFeature } from '@/hooks/useFeature';
import { SubscriptionTier } from '@/graphql/graphql';
import { FeatureKey } from '@/lib/featureGates';
import { cn } from '@/lib/utils';
import { ReactNode } from 'react';

interface FeatureGateProps {
  feature: FeatureKey;
  children: ReactNode;
  fallback?: ReactNode;
}

/**
 * Hide-mode wrapper: renders children only if the feature is allowed.
 * For "disable + tooltip" UX, use the `useFeature` hook directly so the call-site
 * keeps full control over the disabled control's appearance and tooltip text.
 */
export const FeatureGate = ({ feature, children, fallback = null }: FeatureGateProps) => {
  const { allowed } = useFeature(feature);
  return <>{allowed ? children : fallback}</>;
};

interface UpgradeBadgeProps {
  tier: SubscriptionTier;
  className?: string;
}

export const UpgradeBadge = ({ tier, className }: UpgradeBadgeProps) => (
  <span
    className={cn(
      'inline-flex items-center rounded-sm bg-amber-500/15 px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide text-amber-600 dark:text-amber-400',
      className,
    )}>
    {TIER_DISPLAY_NAMES[tier]}
  </span>
);
